import { Link } from "react-router-dom";
import "./python.css";

const PythonDevelopment = () => {

  const modules = [

    {
      no: "01",
      title: "Python Fundamentals",
      icon: "🐍",
      topics: [
        "Introduction to Python",
        "History of Python",
        "Features of Python",
        "Python Installation",
        "Python Interpreter",
        "Python IDEs",
        "Variables",
        "Keywords",
        "Identifiers",
        "Comments",
        "Data Types",
        "Type Conversion",
        "Input & Output",
        "Operators",
        "Arithmetic Operators",
        "Relational Operators",
        "Logical Operators",
        "Assignment Operators"
      ],
    },

    {
      no: "02",
      title: "Conditional Statements & Loops",
      icon: "🔄",
      topics: [
        "if Statement",
        "if-else",
        "if-elif-else",
        "Nested Conditions",
        "for Loop",
        "while Loop",
        "Nested Loops",
        "break",
        "continue",
        "pass",
        "range()",
        "Loop with Strings",
        "Loop with Lists",
        "Loop with Dictionaries",
        "Pattern Programs"
      ],
    },

    {
      no: "03",
      title: "Python Data Structures",
      icon: "📦",
      topics: [
        "Strings",
        "String Methods",
        "String Slicing",
        "Lists",
        "List Methods",
        "List Slicing",
        "Tuples",
        "Tuple Methods",
        "Sets",
        "Set Operations",
        "Dictionaries",
        "Dictionary Methods",
        "Nested Collections",
        "List Comprehension",
        "Dictionary Comprehension",
        "Set Comprehension"
      ],
    },

    {
      no: "04",
      title: "Functions",
      icon: "⚙️",
      topics: [
        "Introduction to Functions",
        "Function Definition",
        "Function Calling",
        "Parameters",
        "Arguments",
        "Default Arguments",
        "Keyword Arguments",
        "Positional Arguments",
        "Variable Length Arguments",
        "*args",
        "**kwargs",
        "Return Statement",
        "Nested Functions",
        "Lambda Functions",
        "Recursive Functions",
        "Higher Order Functions"
      ],
    },

    {
      no: "05",
      title: "Object Oriented Programming",
      icon: "🧩",
      topics: [
        "OOP Introduction",
        "Classes",
        "Objects",
        "Constructors",
        "self Keyword",
        "Instance Variables",
        "Class Variables",
        "Instance Methods",
        "Class Methods",
        "Static Methods",
        "Encapsulation",
        "Inheritance",
        "Single Inheritance",
        "Multilevel Inheritance",
        "Multiple Inheritance",
        "Hierarchical Inheritance",
        "Polymorphism",
        "Method Overriding",
        "Abstraction"
      ],
    },

    {
      no: "06",
      title: "Exception Handling",
      icon: "🛡️",
      topics: [
        "Exception Introduction",
        "Syntax Errors",
        "Runtime Errors",
        "try",
        "except",
        "else",
        "finally",
        "Multiple Exceptions",
        "Custom Exceptions",
        "raise",
        "Exception Hierarchy",
        "User Defined Exceptions",
        "Error Handling Best Practices"
      ],
    },

    {
      no: "07",
      title: "Modules & Packages",
      icon: "📚",
      topics: [
        "Modules",
        "Creating Modules",
        "Import Statement",
        "from import",
        "import as",
        "Built-in Modules",
        "Math Module",
        "Random Module",
        "DateTime Module",
        "OS Module",
        "Sys Module",
        "Packages",
        "Package Structure",
        "Third Party Packages",
        "pip",
        "Virtual Environment"
      ],
    },

    {
      no: "08",
      title: "File Handling",
      icon: "📁",
      topics: [
        "File Handling Introduction",
        "Opening Files",
        "Reading Files",
        "Writing Files",
        "Appending Data",
        "File Modes",
        "with Statement",
        "Text Files",
        "CSV Files",
        "JSON Files",
        "File Exceptions",
        "Directory Handling",
        "OS Module",
        "Path Handling"
      ],
    },

    {
      no: "09",
      title: "Advanced Python",
      icon: "🚀",
      topics: [
        "Iterators",
        "Iterables",
        "Generators",
        "yield",
        "Decorators",
        "Closures",
        "Nested Functions",
        "Map",
        "Filter",
        "Reduce",
        "Zip",
        "Enumerate",
        "Any",
        "All",
        "Regular Expressions",
        "Regex Patterns",
        "Match",
        "Search",
        "Replace"
      ],
    },

    {
      no: "10",
      title: "Database Fundamentals",
      icon: "🗄️",
      topics: [
        "Database Introduction",
        "RDBMS",
        "SQL Basics",
        "Database Creation",
        "Tables",
        "Primary Key",
        "Foreign Key",
        "Constraints",
        "INSERT",
        "SELECT",
        "UPDATE",
        "DELETE",
        "WHERE",
        "ORDER BY",
        "GROUP BY",
        "Joins",
        "Subqueries",
        "Transactions"
      ],
    },

    {
      no: "11",
      title: "Python MySQL Connectivity",
      icon: "🐬",
      topics: [
        "MySQL Introduction",
        "MySQL Connector",
        "Database Connection",
        "Cursor",
        "Execute Query",
        "Insert Data",
        "Read Data",
        "Update Data",
        "Delete Data",
        "Parameterized Queries",
        "Transactions",
        "Commit",
        "Rollback",
        "CRUD Application",
        "Database Error Handling"
      ],
    },

    {
      no: "12",
      title: "Web Development Fundamentals",
      icon: "🌐",
      topics: [
        "Web Development Introduction",
        "Client Server Architecture",
        "HTTP",
        "HTTPS",
        "Request",
        "Response",
        "HTML5",
        "CSS3",
        "Forms",
        "JavaScript Basics",
        "REST API Concepts",
        "JSON",
        "Frontend vs Backend",
        "Web Application Architecture"
      ],
    },

    {
      no: "13",
      title: "Django Fundamentals",
      icon: "🎸",
      topics: [
        "Introduction to Django",
        "Django Installation",
        "Django Project",
        "Django Apps",
        "Project Structure",
        "Settings",
        "URLs",
        "Views",
        "Templates",
        "Template Language",
        "Static Files",
        "Media Files",
        "Forms",
        "Form Validation"
      ],
    },

    {
      no: "14",
      title: "Django Models & ORM",
      icon: "🗃️",
      topics: [
        "Django Models",
        "Model Fields",
        "Primary Key",
        "Relationships",
        "One-to-One",
        "One-to-Many",
        "Many-to-Many",
        "Migrations",
        "makemigrations",
        "migrate",
        "Django ORM",
        "QuerySets",
        "Filtering",
        "Ordering",
        "CRUD Operations",
        "Database Relationships"
      ],
    },

    {
      no: "15",
      title: "Django REST Framework",
      icon: "🔌",
      topics: [
        "REST API",
        "Django REST Framework",
        "Serializers",
        "APIView",
        "Generic Views",
        "ViewSets",
        "Routers",
        "Request",
        "Response",
        "HTTP Methods",
        "Status Codes",
        "CRUD APIs",
        "API Validation",
        "Pagination",
        "Filtering",
        "API Testing"
      ],
    },

    {
      no: "16",
      title: "Authentication & Authorization",
      icon: "🔐",
      topics: [
        "Authentication Concepts",
        "Authorization Concepts",
        "User Registration",
        "Login",
        "Logout",
        "Password Hashing",
        "Django Authentication",
        "Permissions",
        "Groups",
        "Roles",
        "JWT Authentication",
        "Access Token",
        "Refresh Token",
        "Protected APIs",
        "Role Based Access"
      ],
    },

    {
      no: "17",
      title: "Flask Framework",
      icon: "🌶️",
      topics: [
        "Introduction to Flask",
        "Flask Installation",
        "Flask Application",
        "Routing",
        "Views",
        "Request",
        "Response",
        "Templates",
        "Jinja2",
        "Forms",
        "Blueprints",
        "Middleware",
        "Error Handling",
        "REST APIs",
        "JSON Response"
      ],
    },

    {
      no: "18",
      title: "Flask REST API",
      icon: "🔗",
      topics: [
        "REST API Development",
        "GET API",
        "POST API",
        "PUT API",
        "PATCH API",
        "DELETE API",
        "Request Parameters",
        "Query Parameters",
        "JSON",
        "Status Codes",
        "API Validation",
        "Error Handling",
        "Authentication",
        "JWT",
        "Postman Testing"
      ],
    },

    {
      no: "19",
      title: "Python API Integration",
      icon: "🔄",
      topics: [
        "API Concepts",
        "Requests Library",
        "GET Requests",
        "POST Requests",
        "PUT Requests",
        "DELETE Requests",
        "Headers",
        "Parameters",
        "JSON Response",
        "Authentication Headers",
        "API Error Handling",
        "Third Party APIs",
        "API Integration Projects"
      ],
    },

    {
      no: "20",
      title: "Testing & Debugging",
      icon: "🧪",
      topics: [
        "Testing Fundamentals",
        "Unit Testing",
        "pytest",
        "Test Cases",
        "Assertions",
        "Fixtures",
        "API Testing",
        "Postman",
        "Debugging",
        "Logging",
        "Exception Debugging",
        "Code Quality",
        "Testing Best Practices"
      ],
    },

    {
      no: "21",
      title: "Git & GitHub",
      icon: "🐙",
      topics: [
        "Git Introduction",
        "Repository",
        "git init",
        "git clone",
        "git status",
        "git add",
        "git commit",
        "git log",
        "Branch",
        "Merge",
        "Pull",
        "Push",
        "GitHub",
        "Pull Requests",
        ".gitignore",
        "Repository Management"
      ],
    },

    {
      no: "22",
      title: "Deployment & Production",
      icon: "☁️",
      topics: [
        "Production Environment",
        "Virtual Environment",
        "requirements.txt",
        "Environment Variables",
        "Application Configuration",
        "Web Server",
        "Deployment Concepts",
        "Cloud Hosting",
        "Database Deployment",
        "Static Files",
        "Media Files",
        "Domain Configuration",
        "Basic CI/CD Concepts"
      ],
    },

    {
      no: "23",
      title: "Python Full Stack Projects",
      icon: "💼",
      topics: [
        "E-Commerce Application",
        "CRM Application",
        "HRMS Application",
        "Employee Management System",
        "Student Management System",
        "User Registration",
        "Login & Authentication",
        "JWT Authentication",
        "Role Based Access",
        "Admin Dashboard",
        "CRUD Operations",
        "REST API",
        "Database Integration",
        "Django Backend",
        "React Frontend",
        "Project Deployment"
      ],
    },

    {
      no: "24",
      title: "Interview & Placement Preparation",
      icon: "🎯",
      topics: [
        "Python Interview Questions",
        "OOP Interview Questions",
        "Django Interview Questions",
        "Flask Interview Questions",
        "REST API Questions",
        "Database Questions",
        "SQL Questions",
        "Authentication Questions",
        "Coding Problems",
        "DSA Problems",
        "Project Explanation",
        "Resume Preparation",
        "GitHub Profile",
        "Mock Interviews",
        "Technical Interview Preparation"
      ],
    }

  ];


  return (

    <div className="python-page">

      {/* ================= HERO ================= */}

      <section className="python-hero">

        <div className="python-hero-content">

          <span>
            JOB-ORIENTED TRAINING PROGRAM
          </span>

          <h1>
            Python
            <strong>Development</strong>
          </h1>

          <p>
            Learn Python from fundamentals to professional
            application development with OOP, Django, Flask,
            REST APIs, MySQL, authentication, deployment,
            DSA and real-world projects.
          </p>

          <div className="python-hero-buttons">

            <a href="#python-syllabus">
              View Complete Syllabus
            </a>

            <Link to="/contact">
              Enquire Now
            </Link>

          </div>

        </div>

      </section>


      {/* ================= COURSE OVERVIEW ================= */}

      <section className="python-overview">

        <div className="overview-card">
          <strong>24+</strong>
          <span>Learning Modules</span>
        </div>

        <div className="overview-card">
          <strong>10+</strong>
          <span>Technologies</span>
        </div>

        <div className="overview-card">
          <strong>3+</strong>
          <span>Major Projects</span>
        </div>

        <div className="overview-card">
          <strong>100%</strong>
          <span>Practical Training</span>
        </div>

      </section>


      {/* ================= SYLLABUS ================= */}

      <section
        id="python-syllabus"
        className="python-syllabus"
      >

        <div className="syllabus-heading">

          <span>
            COURSE CURRICULUM
          </span>

          <h2>
            Complete Python Development Syllabus
          </h2>

          <p>
            A structured learning path covering Python
            programming, OOP, databases, Django, Flask,
            REST APIs, authentication, deployment,
            DSA and real-world application development.
          </p>

        </div>


        <div className="python-module-grid">

          {modules.map((module) => (

            <article
              className="python-module-card"
              key={module.no}
            >

              <div className="module-top">

                <span className="module-number">
                  {module.no}
                </span>

                <span className="module-icon">
                  {module.icon}
                </span>

              </div>

              <h3>
                {module.title}
              </h3>

              <ul>

                {module.topics.map((topic) => (

                  <li key={topic}>

                    <span>✓</span>

                    {topic}

                  </li>

                ))}

              </ul>

            </article>

          ))}

        </div>

      </section>


      {/* ================= TECHNOLOGY STACK ================= */}

      <section className="technology-section">

        <div className="syllabus-heading">

          <span>
            TECHNOLOGY STACK
          </span>

          <h2>
            Technologies You Will Learn
          </h2>

        </div>

        <div className="technology-grid">

          <div>🐍 Python</div>

          <div>🎸 Django</div>

          <div>🌶️ Flask</div>

          <div>🗄️ MySQL</div>

          <div>🔌 REST API</div>

          <div>🔐 JWT</div>

          <div>📦 Django REST Framework</div>

          <div>🐙 Git & GitHub</div>

          <div>📮 Postman</div>

          <div>☁️ Cloud Deployment</div>

        </div>

      </section>


      {/* ================= PROJECTS ================= */}

      <section className="python-projects">

        <div className="syllabus-heading">

          <span>
            REAL WORLD DEVELOPMENT
          </span>

          <h2>
            Projects You Will Build
          </h2>

        </div>


        <div className="project-training-grid">

          <article>

            <span>
              PROJECT 01
            </span>

            <h3>
              E-Commerce Application
            </h3>

            <p>
              Build a complete Python-based e-commerce
              application with products, users, authentication,
              cart, orders and admin management.
            </p>

          </article>


          <article>

            <span>
              PROJECT 02
            </span>

            <h3>
              CRM Application
            </h3>

            <p>
              Develop a customer relationship management
              application with customers, leads, users,
              dashboards and role-based access.
            </p>

          </article>


          <article>

            <span>
              PROJECT 03
            </span>

            <h3>
              HRMS Application
            </h3>

            <p>
              Create an employee management system with
              employee CRUD, authentication, roles,
              attendance and database integration.
            </p>

          </article>

        </div>

      </section>


      {/* ================= ENQUIRY ================= */}

      <section
        id="python-enquiry"
        className="python-enquiry"
      >

        <div>

          <span>
            START YOUR JOURNEY
          </span>

          <h2>
            Become a Python Developer
          </h2>

          <p>
            Learn industry-relevant Python technologies
            and build real-world applications through
            practical project-based training.
          </p>

        </div>

        <Link to="/contact">
          Enquire Now →
        </Link>

      </section>

    </div>

  );
};

export default PythonDevelopment;